import React, { useState, useEffect, useMemo, useRef } from "react";
import { Table, Container, Input, Row, Col, Button } from 'reactstrap';
import './ProposalStyle.css';
import "./Reports.css";
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function Report61Component() {
    const tableRef = useRef();
    const currentYearTh = new Date().getFullYear() + 543;

    const [budgetYear, setBudgetYear] = useState(currentYearTh);
    const [reportData, setReportData] = useState([]);
    const [yearOptions, setYearOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    async function fetchReport61() {
        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("budgetYear", budgetYear);

            const res = await fetch("/api/SupportReports/dataReport61", {
                method: "POST",
                body: formData
            });

            const json = await res.json();
            setReportData(json.dataenum || []);
        }
        finally {
            setLoading(false);
        }
    }

    async function fetchYearOptions() {
        const res = await fetch("/api/Support/getyear57");
        const json = await res.json();
        setYearOptions(json.dataenum || []);
    }

    useEffect(() => {
        fetchReport61();
        fetchYearOptions();
    }, [budgetYear]);

    /* =========================
       คำนวณงบรวม 3 + 9
    ========================== */
    const mergeData = useMemo(() => {

        const type3 = reportData.find(x => x.supportTypeId === 3);
        const type9 = reportData.find(x => x.supportTypeId === 9);

        if (!type3 || !type9) return null;

        const totalBudget =
            Number(type3.budgetAmount || 0) +
            Number(type9.budgetAmount || 0);

        const approvedMoney =
            Number(type3?.approved?.supportPaymentAmount || 0) +
            Number(type9?.approved?.supportPaymentAmount || 0);

        const approvedTransferMoney =
            Number(type3?.approvedAndTransferedNotPay?.supportPaymentAmount || 0) +
            Number(type9?.approvedAndTransferedNotPay?.supportPaymentAmount || 0);

        const totalAllPayment =
            Number(type3?.approved?.supportPaymentAmount || 0) +
            Number(type3?.transferedNotPay?.supportPaymentAmount || 0) +
            Number(type3?.notTransfered?.supportPaymentAmount || 0) +
            Number(type9?.approved?.supportPaymentAmount || 0) +
            Number(type9?.transferedNotPay?.supportPaymentAmount || 0) +
            Number(type9?.notTransfered?.supportPaymentAmount || 0);

        return {
            totalBudget,
            approvedBalance: totalBudget - approvedMoney,
            approvedTransferBalance: totalBudget - approvedTransferMoney,
            finalBalance: totalBudget - totalAllPayment
        };

    }, [reportData]);

    const summary = useMemo(() => {

        if (!reportData.length) return null;

        const sum = (fn) =>
            reportData.reduce((acc, cur) => acc + fn(cur), 0);

        const totalBudget = sum(r => Number(r?.budgetAmount || 0));

        const approvedMoney = sum(r => Number(r?.approved?.supportPaymentAmount || 0));
        const approvedTransferMoney = sum(r => Number(r?.approvedAndTransferedNotPay?.supportPaymentAmount || 0));

        const transferMoney = sum(r => Number(r?.transferedNotPay?.supportPaymentAmount || 0));
        const notTransferMoney = sum(r => Number(r?.notTransfered?.supportPaymentAmount || 0));

        const totalAllPayment = approvedMoney + transferMoney + notTransferMoney;

        return {
            totalBudget,

            approved_support: sum(r => Number(r?.approved?.supportAmount || 0)),
            approved_person: sum(r => Number(r?.approved?.personAmount || 0)),
            approved_money: approvedMoney,
            approved_balance: totalBudget - approvedMoney,

            approvedTransfer_support: sum(r => Number(r?.approvedAndTransferedNotPay?.supportAmount || 0)),
            approvedTransfer_person: sum(r => Number(r?.approvedAndTransferedNotPay?.personAmount || 0)),
            approvedTransfer_money: approvedTransferMoney,
            approvedTransfer_balance: totalBudget - approvedTransferMoney,

            transfer_support: sum(r => Number(r?.transferedNotPay?.supportAmount || 0)),
            transfer_person: sum(r => Number(r?.transferedNotPay?.personAmount || 0)),
            transfer_money: transferMoney,

            notTransfer_support: sum(r => Number(r?.notTransfered?.supportAmount || 0)),
            notTransfer_person: sum(r => Number(r?.notTransfered?.personAmount || 0)),
            notTransfer_money: notTransferMoney,

            total_support: sum(r =>
                Number(r?.approved?.supportAmount || 0) +
                Number(r?.transferedNotPay?.supportAmount || 0) +
                Number(r?.notTransfered?.supportAmount || 0)
            ),

            total_person: sum(r =>
                Number(r?.approved?.personAmount || 0) +
                Number(r?.transferedNotPay?.personAmount || 0) +
                Number(r?.notTransfered?.personAmount || 0)
            ),

            total_money: totalAllPayment,

            final_balance: totalBudget - totalAllPayment
        };

    }, [reportData]);

    const handleExportExcel = () => {

        if (!reportData.length) return;

        const wb = XLSX.utils.book_new();

        /* =========================
           1️⃣ สร้าง Header 3 ชั้น
        ========================== */

        const header = [
            [
                "รายการ",
                "งบประมาณ",
                `อนุมัติจ่ายเงินอุดหนุนแล้ว (ต.ค.${budgetYear - 1} - ก.ย.${budgetYear})`,
                "",
                "",
                "คงเหลือ (บาท)",
                "อนุมัติ+โอนแล้วยังไม่จ่าย",
                "",
                "",
                "คงเหลือ (บาท)",
                "ยังไม่จ่ายเงินช่วยเหลือหรืออุดหนุน",
                "", "", "", "", "", "", "", "",
                "รวม (เบิกจ่ายแล้ว+ยังไม่เบิกจ่าย)",
                "", "",
                "งบประมาณคงเหลือ (บาท)"
            ],
            [
                "", "",
                "(แห่ง)", "คน", "จำนวนเงิน (บาท)",
                "",
                "(แห่ง)", "คน", "จำนวนเงิน (บาท)",
                "",
                "โอนแล้วยังไม่จ่าย", "", "",
                "ยังไม่โอน", "", "",
                "รวม", "", "",
                "(แห่ง)", "คน", "จำนวนเงิน (บาท)",
                ""
            ],
            [
                "", "", "", "", "", "", "", "", "", "",
                "(แห่ง)", "คน", "จำนวนเงิน (บาท)",
                "(แห่ง)", "คน", "จำนวนเงิน (บาท)",
                "(แห่ง)", "คน", "จำนวนเงิน (บาท)",
                "", "", "", ""
            ]
        ];

        /* =========================
           2️⃣ สร้าง Body
        ========================== */

        const body = reportData.map(row => ([
            row.supportDetail,
            Number(row.budgetAmount || 0),

            Number(row?.approved?.supportAmount || 0),
            Number(row?.approved?.personAmount || 0),
            Number(row?.approved?.supportPaymentAmount || 0),

            Number(row?.budgetAmount || 0) -
            Number(row?.approved?.supportPaymentAmount || 0),

            Number(row?.approvedAndTransferedNotPay?.supportAmount || 0),
            Number(row?.approvedAndTransferedNotPay?.personAmount || 0),
            Number(row?.approvedAndTransferedNotPay?.supportPaymentAmount || 0),

            Number(row?.budgetAmount || 0) -
            Number(row?.approvedAndTransferedNotPay?.supportPaymentAmount || 0),

            Number(row?.transferedNotPay?.supportAmount || 0),
            Number(row?.transferedNotPay?.personAmount || 0),
            Number(row?.transferedNotPay?.supportPaymentAmount || 0),

            Number(row?.notTransfered?.supportAmount || 0),
            Number(row?.notTransfered?.personAmount || 0),
            Number(row?.notTransfered?.supportPaymentAmount || 0),

            Number(row?.transferedNotPay?.supportAmount || 0) +
            Number(row?.notTransfered?.supportAmount || 0),

            Number(row?.transferedNotPay?.personAmount || 0) +
            Number(row?.notTransfered?.personAmount || 0),

            Number(row?.transferedNotPay?.supportPaymentAmount || 0) +
            Number(row?.notTransfered?.supportPaymentAmount || 0),

            Number(row?.approved?.supportAmount || 0) +
            Number(row?.transferedNotPay?.supportAmount || 0) +
            Number(row?.notTransfered?.supportAmount || 0),

            Number(row?.approved?.personAmount || 0) +
            Number(row?.transferedNotPay?.personAmount || 0) +
            Number(row?.notTransfered?.personAmount || 0),

            Number(row?.approved?.supportPaymentAmount || 0) +
            Number(row?.transferedNotPay?.supportPaymentAmount || 0) +
            Number(row?.notTransfered?.supportPaymentAmount || 0),

            Number(row?.budgetAmount || 0) -
            (
                Number(row?.approved?.supportPaymentAmount || 0) +
                Number(row?.transferedNotPay?.supportPaymentAmount || 0) +
                Number(row?.notTransfered?.supportPaymentAmount || 0)
            )
        ]));

        /* =========================
           3️⃣ รวมทั้งหมด
        ========================== */

        const wsData = [...header, ...body];

        const ws = XLSX.utils.aoa_to_sheet(wsData);

        /* =========================
           4️⃣ กำหนด Merge Header
        ========================== */

        ws["!merges"] = [

            // ===== Row 0 (แถวบนสุด) =====
            { s: { r: 0, c: 0 }, e: { r: 2, c: 0 } }, // รายการ
            { s: { r: 0, c: 1 }, e: { r: 2, c: 1 } }, // งบประมาณ

            { s: { r: 0, c: 2 }, e: { r: 0, c: 4 } }, // อนุมัติ
            { s: { r: 0, c: 5 }, e: { r: 2, c: 5 } }, // คงเหลือ

            { s: { r: 0, c: 6 }, e: { r: 0, c: 8 } }, // อนุมัติ+โอน
            { s: { r: 0, c: 9 }, e: { r: 2, c: 9 } }, // คงเหลือ

            { s: { r: 0, c: 10 }, e: { r: 0, c: 18 } }, // ยังไม่จ่าย 9 ช่อง
            { s: { r: 0, c: 19 }, e: { r: 0, c: 21 } }, // รวม
            { s: { r: 0, c: 22 }, e: { r: 2, c: 22 } }, // งบคงเหลือ

            // ===== Row 1 =====
            { s: { r: 1, c: 2 }, e: { r: 2, c: 2 } },
            { s: { r: 1, c: 3 }, e: { r: 2, c: 3 } },
            { s: { r: 1, c: 4 }, e: { r: 2, c: 4 } },

            { s: { r: 1, c: 6 }, e: { r: 2, c: 6 } },
            { s: { r: 1, c: 7 }, e: { r: 2, c: 7 } },
            { s: { r: 1, c: 8 }, e: { r: 2, c: 8 } },

            // ยังไม่จ่าย → แบ่ง 3 กลุ่ม
            { s: { r: 1, c: 10 }, e: { r: 1, c: 12 } }, // โอนแล้วยังไม่จ่าย
            { s: { r: 1, c: 13 }, e: { r: 1, c: 15 } }, // ยังไม่โอน
            { s: { r: 1, c: 16 }, e: { r: 1, c: 18 } }, // รวม

            { s: { r: 1, c: 19 }, e: { r: 2, c: 19 } },
            { s: { r: 1, c: 20 }, e: { r: 2, c: 20 } },
            { s: { r: 1, c: 21 }, e: { r: 2, c: 21 } }

        ];

        /* =========================
           5️⃣ ตั้ง Column Width
        ========================== */

        ws["!cols"] = Array(23).fill({ wch: 14 });

        XLSX.utils.book_append_sheet(wb, ws, "Report61");

        XLSX.writeFile(wb, `Report61_${budgetYear}.xlsx`);
    };


    function base64FromArrayBuffer(buf) {
        const bytes = new Uint8Array(buf);
        const chunkSize = 0x8000;
        let binary = "";
        for (let i = 0; i < bytes.length; i += chunkSize) {
            binary += String.fromCharCode.apply(
                null,
                bytes.subarray(i, i + chunkSize)
            );
        }
        return btoa(binary);
    }

    let thaiFontLoaded = false;

    async function ensureThaiFontLoaded() {
        if (thaiFontLoaded) return;

        const [regRes, boldRes] = await Promise.all([
            fetch("/fonts/Sarabun-Regular.ttf"),
            fetch("/fonts/Sarabun-Bold.ttf")
        ]);

        const [regBuf, boldBuf] = await Promise.all([
            regRes.arrayBuffer(),
            boldRes.arrayBuffer()
        ]);

        const regB64 = base64FromArrayBuffer(regBuf);
        const boldB64 = base64FromArrayBuffer(boldBuf);

        jsPDF.API.events.push([
            "addFonts",
            function () {
                this.addFileToVFS("Sarabun-Regular.ttf", regB64);
                this.addFileToVFS("Sarabun-Bold.ttf", boldB64);
                this.addFont("Sarabun-Regular.ttf", "Sarabun", "normal");
                this.addFont("Sarabun-Bold.ttf", "Sarabun", "bold");
            }
        ]);

        new jsPDF();
        thaiFontLoaded = true;
    }

    async function handleExportPDF() {

        if (!reportData.length) return;

        await ensureThaiFontLoaded();

        const doc = new jsPDF({
            orientation: "landscape",
            unit: "pt",
            format: "a3"
        });

        /* =========================
           หัวรายงาน
        ========================== */

        doc.setFont("Sarabun", "bold");
        doc.setFontSize(16);
        doc.text(
            `รายงานสรุปเงินช่วยเหลือหรืออุดหนุน ปีงบประมาณ ${budgetYear}`,
            40,
            40
        );

        doc.setFont("Sarabun", "normal");

        /* =========================
           HEADER 3 ชั้น
        ========================== */

        const head = [
            [
                { content: "รายการ", rowSpan: 3 },
                { content: "งบประมาณ", rowSpan: 3 },
                { content: "อนุมัติจ่ายแล้ว", colSpan: 3 },
                { content: "คงเหลือ", rowSpan: 3 },
                { content: "อนุมัติ+โอนแล้วยังไม่จ่าย", colSpan: 3 },
                { content: "คงเหลือ", rowSpan: 3 },
                { content: "ยังไม่จ่ายเงิน", colSpan: 9 },
                { content: "รวมทั้งหมด", colSpan: 3 },
                { content: "งบคงเหลือ", rowSpan: 3 }
            ],
            [
                { content: "(แห่ง)", rowSpan: 2 },
                { content: "คน", rowSpan: 2 },
                { content: "จำนวนเงิน", rowSpan: 2 },

                { content: "(แห่ง)", rowSpan: 2 },
                { content: "คน", rowSpan: 2 },
                { content: "จำนวนเงิน", rowSpan: 2 },

                { content: "โอนแล้ว", colSpan: 3 },
                { content: "ยังไม่โอน", colSpan: 3 },
                { content: "รวม", colSpan: 3 },

                { content: "(แห่ง)", rowSpan: 2 },
                { content: "คน", rowSpan: 2 },
                { content: "จำนวนเงิน", rowSpan: 2 }
            ],
            [
                "(แห่ง)", "คน", "จำนวนเงิน",
                "(แห่ง)", "คน", "จำนวนเงิน",
                "(แห่ง)", "คน", "จำนวนเงิน"
            ]
        ];

        /* =========================
           BODY
        ========================== */

        const body = reportData.map(row => ([
            row.supportDetail,
            NumberWithCommmas2(row.budgetAmount || 0),

            row?.approved?.supportAmount || 0,
            row?.approved?.personAmount || 0,
            NumberWithCommmas2(row?.approved?.supportPaymentAmount || 0),

            NumberWithCommmas2(
                (row.budgetAmount || 0) -
                (row?.approved?.supportPaymentAmount || 0)
            ),

            row?.approvedAndTransferedNotPay?.supportAmount || 0,
            row?.approvedAndTransferedNotPay?.personAmount || 0,
            NumberWithCommmas2(row?.approvedAndTransferedNotPay?.supportPaymentAmount || 0),

            NumberWithCommmas2(
                (row.budgetAmount || 0) -
                (row?.approvedAndTransferedNotPay?.supportPaymentAmount || 0)
            ),

            row?.transferedNotPay?.supportAmount || 0,
            row?.transferedNotPay?.personAmount || 0,
            NumberWithCommmas2(row?.transferedNotPay?.supportPaymentAmount || 0),

            row?.notTransfered?.supportAmount || 0,
            row?.notTransfered?.personAmount || 0,
            NumberWithCommmas2(row?.notTransfered?.supportPaymentAmount || 0),

            row?.transferedNotPay?.supportAmount + row?.notTransfered?.supportAmount,
            row?.transferedNotPay?.personAmount + row?.notTransfered?.personAmount,
            NumberWithCommmas2(
                row?.transferedNotPay?.supportPaymentAmount +
                row?.notTransfered?.supportPaymentAmount
            ),

            row?.approved?.supportAmount +
            row?.transferedNotPay?.supportAmount +
            row?.notTransfered?.supportAmount,

            row?.approved?.personAmount +
            row?.transferedNotPay?.personAmount +
            row?.notTransfered?.personAmount,

            NumberWithCommmas2(
                row?.approved?.supportPaymentAmount +
                row?.transferedNotPay?.supportPaymentAmount +
                row?.notTransfered?.supportPaymentAmount
            ),

            NumberWithCommmas2(
                (row.budgetAmount || 0) -
                (
                    row?.approved?.supportPaymentAmount +
                    row?.transferedNotPay?.supportPaymentAmount +
                    row?.notTransfered?.supportPaymentAmount
                )
            )
        ]));

        /* =========================
           TABLE
        ========================== */

        doc.autoTable({
            startY: 60,
            head: head,
            body: body,
            styles: {
                font: "Sarabun",
                fontSize: 7,
                halign: "right"
            },
            headStyles: {
                font: "Sarabun",
                fontStyle: "bold",
                halign: "center"
            },
            columnStyles: {
                0: { halign: "left" }
            },
            theme: "grid"
        });

        doc.save(`Report61_${budgetYear}.pdf`);
    }
    return (
        <Container>

            <Row className="mb-3 align-items-center">
                <Col md={4} className="text-end"><h5>ปีงบประมาณ</h5></Col>
                <Col md={4}>
                    <Input
                        type="select"
                        value={budgetYear}
                        disabled={loading}
                        onChange={e => setBudgetYear(e.target.value)}
                    >
                        {yearOptions.map(y => (
                            <option key={y.yearTh} value={y.yearTh}>
                                {y.yearTh}
                            </option>
                        ))}
                    </Input>
                </Col>
                <Col md={4} className="text-end">
                    <Button
                        className="btn-export excel me-2"
                        onClick={handleExportExcel}
                        disabled={loading || !reportData.length}
                    >
                        Excel
                    </Button>
                    <Button
                        className="btn-export pdf"
                        onClick={handleExportPDF}
                        disabled={loading || !reportData.length}
                    >
                        PDF
                    </Button>
                </Col>
            </Row>

            <Table innerRef={tableRef} bordered responsive className="report-table"

                style={{ minWidth: "3000px" }}>
                <thead>
                    {/* ===== HEADER เดิมของคุณ 100% ===== */}
                    <tr>
                        <th rowSpan="3">รายการ</th>
                        <th rowSpan="3" className='text-center'>งบประมาณ</th>
                        <th colSpan="3" className=' text-center'>
                            อนุมัติจ่ายเงินอุดหนุนแล้ว (ต.ค.{budgetYear - 1} - ก.ย.{budgetYear})
                        </th>
                        <th rowSpan="3" className=' text-center'>คงเหลือ (บาท)</th>
                        <th colSpan="3" className=' text-center'>อนุมัติ+โอนแล้วยังไม่จ่าย</th>
                        <th rowSpan="3" className=' text-center'>คงเหลือ (บาท)</th>
                        <th colSpan="9" className=' text-center'>ยังไม่จ่ายเงินช่วยเหลือหรืออุดหนุน</th>
                        <th colSpan="3" className=' text-center'>รวม (เบิกจ่ายแล้ว+ยังไม่เบิกจ่าย)</th>
                        <th rowSpan="3" className=' text-center'>งบประมาณคงเหลือ (บาท)</th>
                    </tr>
                    <tr>
                        <th rowSpan="3" className='text-center'>(แห่ง)</th>
                        <th rowSpan="3" className='text-center'>คน</th>
                        <th rowSpan="3" className='text-center'>จำนวนเงิน (บาท)</th>
                        <th rowSpan="3" className='text-center'>(แห่ง)</th>
                        <th rowSpan="3" className='text-center'>คน</th>
                        <th rowSpan="3" className='text-center'>จำนวนเงิน (บาท)</th>
                        <th colSpan="3" className='text-center'>โอนแล้วยังไม่จ่าย</th>
                        <th colSpan="3" className='text-center'>ยังไม่โอน</th>
                        <th colSpan="3" className='text-center'>รวม</th>
                        <th rowSpan="3" className='text-center'>(แห่ง)</th>
                        <th rowSpan="3" className='text-center'>คน</th>
                        <th rowSpan="3" className='text-center'>จำนวนเงิน (บาท)</th>
                    </tr>
                    <tr>
                        <th className='text-center'>(แห่ง)</th>
                        <th className='text-center'>คน</th>
                        <th className='text-center'>จำนวนเงิน (บาท)</th>
                        <th className='text-center'>(แห่ง)</th>
                        <th className='text-center'>คน</th>
                        <th className='text-center'>จำนวนเงิน (บาท)</th>
                        <th className='text-center'>(แห่ง)</th>
                        <th className='text-center'>คน</th>
                        <th className='text-center'>จำนวนเงิน (บาท)</th>
                    </tr>
                </thead>

                <tbody>
                    {reportData.map((row, i) => {

                        const isType3 = row.supportTypeId === 3;
                        const isType9 = row.supportTypeId === 9;
                        const shouldMerge = mergeData && (isType3 || isType9);

                        return (
                            <tr key={i}>

                                <td>{row.supportDetail}</td>

                                {/* ===== งบประมาณ (merge เฉพาะ 3) ===== */}
                                {isType3 && shouldMerge ? (
                                    <td rowSpan="2" className="text-end align-middle">
                                        {NumberWithCommmas2(mergeData.totalBudget)}
                                    </td>
                                ) : !isType9 ? (
                                    <td className="text-end">
                                        {NumberWithCommmas2(Number(row.budgetAmount || 0))}
                                    </td>
                                ) : null}

                                {/* ===== อนุมัติแล้ว (เดิมครบทุก column) ===== */}
                                <td className="text-end">
                                    {NumberWithCommmas2(Number(row?.approved?.supportAmount || 0))}
                                </td>
                                <td className="text-end">
                                    {NumberWithCommmas2(Number(row?.approved?.personAmount || 0))}
                                </td>
                                <td className="text-end">
                                    {NumberWithCommmas2(Number(row?.approved?.supportPaymentAmount || 0))}
                                </td>

                                {/* ===== คงเหลือหลังอนุมัติ (merge) ===== */}
                                {isType3 && shouldMerge ? (
                                    <td rowSpan="2" className="text-end align-middle">
                                        {NumberWithCommmas2(mergeData.approvedBalance)}
                                    </td>
                                ) : !isType9 ? (
                                    <td className="text-end">
                                        {NumberWithCommmas2(
                                            Number(row?.budgetAmount || 0) -
                                            Number(row?.approved?.supportPaymentAmount || 0)
                                        )}
                                    </td>
                                ) : null}

                                {/* ===== อนุมัติ+โอนแล้วยังไม่จ่าย (เดิมครบ) ===== */}
                                <td className="text-end">
                                    {NumberWithCommmas2(Number(row?.approvedAndTransferedNotPay?.supportAmount || 0))}
                                </td>
                                <td className="text-end">
                                    {NumberWithCommmas2(Number(row?.approvedAndTransferedNotPay?.personAmount || 0))}
                                </td>
                                <td className="text-end">
                                    {NumberWithCommmas2(Number(row?.approvedAndTransferedNotPay?.supportPaymentAmount || 0))}
                                </td>

                                {/* ===== คงเหลือหลังอนุมัติ+โอน (merge) ===== */}
                                {isType3 && shouldMerge ? (
                                    <td rowSpan="2" className="text-end align-middle">
                                        {NumberWithCommmas2(mergeData.approvedTransferBalance)}
                                    </td>
                                ) : !isType9 ? (
                                    <td className="text-end">
                                        {NumberWithCommmas2(
                                            Number(row?.budgetAmount || 0) -
                                            Number(row?.approvedAndTransferedNotPay?.supportPaymentAmount || 0)
                                        )}
                                    </td>
                                ) : null}

                                {/* ===== โอนแล้วยังไม่จ่าย (เดิมครบ) ===== */}
                                <td className="text-end">
                                    {NumberWithCommmas2(Number(row?.transferedNotPay?.supportAmount || 0))}
                                </td>
                                <td className="text-end">
                                    {NumberWithCommmas2(Number(row?.transferedNotPay?.personAmount || 0))}
                                </td>
                                <td className="text-end">
                                    {NumberWithCommmas2(Number(row?.transferedNotPay?.supportPaymentAmount || 0))}
                                </td>

                                {/* ===== ยังไม่โอน (เดิมครบ) ===== */}
                                <td className="text-end">
                                    {NumberWithCommmas2(Number(row?.notTransfered?.supportAmount || 0))}
                                </td>
                                <td className="text-end">
                                    {NumberWithCommmas2(Number(row?.notTransfered?.personAmount || 0))}
                                </td>
                                <td className="text-end">
                                    {NumberWithCommmas2(Number(row?.notTransfered?.supportPaymentAmount || 0))}
                                </td>

                                {/* ===== รวม (เดิมครบ) ===== */}
                                <td className="text-end">
                                    {NumberWithCommmas2(
                                        Number(row?.transferedNotPay?.supportAmount || 0) +
                                        Number(row?.notTransfered?.supportAmount || 0)
                                    )}
                                </td>
                                <td className="text-end">
                                    {NumberWithCommmas2(
                                        Number(row?.transferedNotPay?.personAmount || 0) +
                                        Number(row?.notTransfered?.personAmount || 0)
                                    )}
                                </td>
                                <td className="text-end">
                                    {NumberWithCommmas2(
                                        Number(row?.transferedNotPay?.supportPaymentAmount || 0) +
                                        Number(row?.notTransfered?.supportPaymentAmount || 0)
                                    )}
                                </td>

                                {/* ===== รวมทั้งหมด (เดิมครบ) ===== */}
                                <td className="text-end">
                                    {NumberWithCommmas2(
                                        Number(row?.approved?.supportAmount || 0) +
                                        Number(row?.transferedNotPay?.supportAmount || 0) +
                                        Number(row?.notTransfered?.supportAmount || 0)
                                    )}
                                </td>
                                <td className="text-end">
                                    {NumberWithCommmas2(
                                        Number(row?.approved?.personAmount || 0) +
                                        Number(row?.transferedNotPay?.personAmount || 0) +
                                        Number(row?.notTransfered?.personAmount || 0)
                                    )}
                                </td>
                                <td className="text-end">
                                    {NumberWithCommmas2(
                                        Number(row?.approved?.supportPaymentAmount || 0) +
                                        Number(row?.transferedNotPay?.supportPaymentAmount || 0) +
                                        Number(row?.notTransfered?.supportPaymentAmount || 0)
                                    )}
                                </td>

                                {/* ===== งบประมาณคงเหลือสุดท้าย (merge) ===== */}
                                {isType3 && shouldMerge ? (
                                    <td rowSpan="2" className="text-end align-middle">
                                        {NumberWithCommmas2(mergeData.finalBalance)}
                                    </td>
                                ) : !isType9 ? (
                                    <td className="text-end">
                                        {NumberWithCommmas2(
                                            Number(row?.budgetAmount || 0) -
                                            (
                                                Number(row?.approved?.supportPaymentAmount || 0) +
                                                Number(row?.transferedNotPay?.supportPaymentAmount || 0) +
                                                Number(row?.notTransfered?.supportPaymentAmount || 0)
                                            )
                                        )}
                                    </td>
                                ) : null}

                            </tr>
                        );
                    })}

                    {summary && (
                        <tr className="fw-bold table-secondary">

                            <td>รวมทั้งสิ้น</td>

                            <td className="text-end">
                                {NumberWithCommmas2(summary.totalBudget)}
                            </td>

                            <td className="text-end">{NumberWithCommmas2(summary.approved_support)}</td>
                            <td className="text-end">{NumberWithCommmas2(summary.approved_person)}</td>
                            <td className="text-end">{NumberWithCommmas2(summary.approved_money)}</td>
                            <td className="text-end">{NumberWithCommmas2(summary.approved_balance)}</td>

                            <td className="text-end">{NumberWithCommmas2(summary.approvedTransfer_support)}</td>
                            <td className="text-end">{NumberWithCommmas2(summary.approvedTransfer_person)}</td>
                            <td className="text-end">{NumberWithCommmas2(summary.approvedTransfer_money)}</td>
                            <td className="text-end">{NumberWithCommmas2(summary.approvedTransfer_balance)}</td>

                            <td className="text-end">{NumberWithCommmas2(summary.transfer_support)}</td>
                            <td className="text-end">{NumberWithCommmas2(summary.transfer_person)}</td>
                            <td className="text-end">{NumberWithCommmas2(summary.transfer_money)}</td>

                            <td className="text-end">{NumberWithCommmas2(summary.notTransfer_support)}</td>
                            <td className="text-end">{NumberWithCommmas2(summary.notTransfer_person)}</td>
                            <td className="text-end">{NumberWithCommmas2(summary.notTransfer_money)}</td>

                            <td className="text-end">
                                {NumberWithCommmas2(summary.transfer_support + summary.notTransfer_support)}
                            </td>
                            <td className="text-end">
                                {NumberWithCommmas2(summary.transfer_person + summary.notTransfer_person)}
                            </td>
                            <td className="text-end">
                                {NumberWithCommmas2(summary.transfer_money + summary.notTransfer_money)}
                            </td>

                            <td className="text-end">{NumberWithCommmas2(summary.total_support)}</td>
                            <td className="text-end">{NumberWithCommmas2(summary.total_person)}</td>
                            <td className="text-end">{NumberWithCommmas2(summary.total_money)}</td>

                            <td className="text-end">
                                {NumberWithCommmas2(summary.final_balance)}
                            </td>

                        </tr>
                    )}
                </tbody>
            </Table>
        </Container>
    )
}



